import { AnalyticsService } from './../../services/analytics.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { ShopSettings } from 'shared';
import { ShopService } from 'src/app/shop/shop.service';
import { environment } from './../../../environments/environment';

@Component({
  selector: 'app-giftcards',
  templateUrl: './giftcards.component.html',
  styleUrls: ['./giftcards.component.scss']
})
export class GiftcardsComponent implements OnInit {
  giftcardOptions = environment.stripe.gcPaymentLinks;
  constructor(public analyticsService: AnalyticsService, private shopService: ShopService) {}
  shopSettings$: Observable<ShopSettings>;

  ngOnInit(): void {
    this.shopSettings$ = this.shopService.shopSettings$();
  }
}
